"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function menuLoadImg(elem) {
  var parent = elem.parentElement;
  var bg = elem.dataset.bgImg;
  var filter = document.createElement('div');
  var filter_hover = document.createElement('div');
  filter.className = "filter filter-third";
  filter_hover.className = "filter filter-primary";
  elem.appendChild(filter);
  elem.appendChild(filter_hover);

  if (bg) {
    elem.style.backgroundImage = "url(" + bg + ")";
  }
}

function menuLoadProductTypeImg(elem) {
  var parent = elem.parentElement;
  var bg = elem.dataset.bgImg;
  var filter = document.createElement('div');
  var filter_hover = document.createElement('div');
  filter.className = "filter filter-third";
  filter_hover.className = "filter filter-primary";
  elem.appendChild(filter);
  elem.appendChild(filter_hover);

  if (bg) {
    elem.style.backgroundImage = "url(" + bg + ")";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var item = _toConsumableArray(document.getElementsByClassName("js-domains-img"));

  item.forEach(function (item) {
    menuLoadImg(item);
  });

  var product_type = _toConsumableArray(document.getElementsByClassName("js-product-type-img"));

  product_type.forEach(function (product_type) {
    menuLoadProductTypeImg(product_type);
  });
});